import { render } from "./WarningDlg.vue?vue&type=template&id=f2f90670"
import script from "./WarningDlg.vue?vue&type=script&lang=js"
export * from "./WarningDlg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__